export const COLOR_PRESETS = ['blue', 'green', 'yellow', 'orange', 'purple']
